<template>
	<div class="row">
		<page-title :title="$t('register')" :showTitle="false"></page-title>
		<div class="col-sm-12 col-md-8 col-lg-8 mx-auto mt-5">
			<div class="loader" v-if="loading"></div>
			<div class="card" v-if="!loading">
				<div class="card-header bg-primary text-white">
					<div class="card-title h5 m-0">{{$t('register')}}</div>
				</div>
				<div class="card-body">
					<div class="form-group">
						<label for="userName" class="font-weight-bold required">{{`${$t('email')}`}}</label>
						<input
                            v-model="userName"
                            id="userName"
                            type="text"
                            class="form-control"
                            name="userName"
                            :disabled="!!holderEmail"
                            :data-vv-as="$t('email')"
                            v-validate="'required|email'"
                            autocomplete="off" />
						<span class="text-danger">{{ errors.first('userName') }}</span>
						<div class="text-danger radio-message-danger mt-2">
							<i class="fa fa-exclamation-circle mr-2"></i>
							<strong>{{ $t("important") }}</strong><br />
                            <p v-if="holderIdentifier">Уважаеми потребители, за да използвате функцията „Вход с КЕП“ е необходимо да извършите първоначална регистрация с цел попълване на всички задължителни полета.</p>
                            <p>{{ $t("registerMoodleEmailUsage") }} {{ $t("registerEmailInfo") }}</p>
                            <div class="mt-2"><strong>{{ $t("consent") }}</strong></div>
						</div>
					</div>
					<div class="form-group">
						<label for="password" class="font-weight-bold required">{{$t('password')}}</label>
						<input
							id="password"
							type="password"
							class="form-control"
							name="password"
							ref="passwordRef"
							:data-vv-as="$t('password')"
							v-model="password"
							v-validate="'required|upCaseNum'"
							aria-describedby="passwordHelp"
                            autocomplete="off"
						/>
						<span v-if="errors.has('password')" class="text-danger">{{ errors.first('password') }}</span>
						<small v-else id="passwordHelp" class="form-text text-muted">{{$t('registerPasswordHelp')}}</small>
					</div>
					<div class="form-group">
						<label for="passwordConfirm" class="font-weight-bold required">{{$t('confirmPassword')}}</label>
						<input
							id="passwordConfirm"
							type="password"
							class="form-control"
							name="passwordConfirm"
							:data-vv-as="$t('confirmPassword')"
							v-model="passwordConfirm"
							v-validate="`required|confirmPass:${password}`"
						/>
						<span class="text-danger">{{ errors.first('passwordConfirm') }}</span>
					</div>

					<div class="form-group">
						<PersonEditCard
							class="mt-3"
							v-model="person"
							:isRegistration="true"
							:validateEgn="true"
							:hideBtns="true"
							:positionStatIsRequired="true"
							:positionIsRequired="true"
                            :disabled-person-identification="!!holderIdentifier"
						></PersonEditCard>
					</div>

					<!--<person :person="person" :showSearchBox="false" :requiredIdentification="false"></person>-->
					<div>
						<button class="btn btn-lg btn-primary float-right" @click="register" :disabled="loading">{{$t('register')}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import authService from '@/services/auth.service';
import PageTitle from '@/components/common/PageTitle';
import { HttpStatusCode, IdentificationTypes } from '@/models/enums';
import { Person } from '@/models/models';
import PersonEditCard from '@/components/person/PersonEditCard';

export default {
	components: {
		PageTitle,
		PersonEditCard
	},
    props: {
        holderIdentifier: {
            type: String,
            default: ''
        },
        holderEmail: {
            type: String,
            default: ''
        },
        holderFirstName: {
            type: String,
            default: ''
        },
        holderFirstNameEn: {
            type: String,
            default: ''
        },
        holderMiddleName: {
            type: String,
            default: ''
        },
        holderMiddleNameEn: {
            type: String,
            default: ''
        },
        holderLastName: {
            type: String,
            default: ''
        },
        holderLastNameEn: {
            type: String,
            default: ''
        }
    },
	data: function() {
		return {
			userName: this.holderEmail,
			password: '',
			passwordConfirm: '',
			loading: false,
			person: new Person({
                firstName: this.holderFirstName,
                middleName: this.holderMiddleName,
                lastName: this.holderLastName,
                firstNameEn: this.holderFirstNameEn,
                middleNameEn: this.holderMiddleNameEn,
                lastNameEn: this.holderLastNameEn,
                email: this.holderEmail,
                personIdentification: this.holderIdentifier
                ? { number: this.holderIdentifier, identificationTypeId: IdentificationTypes.EGN }
                : null
            })
		};
	},
    mounted() {
        const input = document.getElementById('userName');
            if (input) {
                input.focus()
            }
    },
	methods: {
		register() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.loading = true;
					authService
						.register({
							email: this.person.email,
							userName: this.userName,
							password: this.password,
							passwordConfirm: this.passwordConfirm,
							person: this.person
						})
						.then(async (data) => {
                            this.$store.dispatch('setUserData', data);
                            await this.$store.dispatch('loadUserSettingsAsync');
                            this.$store.commit('updateClaims', JSON.parse(localStorage.getItem('user')).userClaims);
							this.person.userId = data.userId;
							this.$http.post('/api/person/register', this.person);
							this.loading = false;

                            const { returnUrl } = this.$route.query;
							this.$router.push({ path: returnUrl || '/' });
						})
						.catch(error => {
							this.loading = false;
							if (error.response.status === HttpStatusCode.BadRequest) {
								if (error.response.data.showMsg === true) {
									this.$vs.notify({
										title: this.$t('notifications.error'),
										text: this.$helpers.errorText(error),
										position: 'top-center',
										color: this.$helpers.errorColor(error)
									});
								} else {
									this.$vs.notify({
										title: this.$t('notifications.error'),
										text: this.$t('notifications.invalidData'),
										position: 'top-center',
										color: 'danger'
									});
								}
							} else {
								this.$vs.notify({
									title: this.$t('notifications.error'),
									text: this.$t('notifications.serverError'),
									position: 'top-center',
									color: 'danger'
								});
							}
						});
				}
			});
		}
	},
	watch: {
		userName: function(val) {
			this.person.email = val;
		}
	}
};
</script>

<style scoped>
    input[name="userName"] {
        border: solid;
        border-width: revert;
        border-color: #009688;
    }
</style>

